export const BusinessType = {
  "BAR": 0,
  "HOTEL": 1,
  "RESIDENTIAL": 2,
  "COWORKING": 3,
  "AIRPORT": 4
}